import { render, staticRenderFns } from "./IncrementTiers.vue?vue&type=template&id=2680ed12&scoped=true"
import script from "./IncrementTiers.vue?vue&type=script&lang=js"
export * from "./IncrementTiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2680ed12",
  null
  
)

export default component.exports